/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowSubsystemAuditStepActivePayer
 */
export interface ShadowSubsystemAuditStepActivePayer {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name?: string | null;
    /**
     * screener_insurance_payors.id of the active payer; absent on older decisions.
     */
    payer_id?: string | null;
    /**
     * Insurance type of the active payer; absent on older decisions.
     */
    type?: ShadowSubsystemAuditStepActivePayerTypeEnum;
}


/**
 * @export
 */
export const ShadowSubsystemAuditStepActivePayerTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type ShadowSubsystemAuditStepActivePayerTypeEnum = typeof ShadowSubsystemAuditStepActivePayerTypeEnum[keyof typeof ShadowSubsystemAuditStepActivePayerTypeEnum];


/**
 * Check if a given object implements the ShadowSubsystemAuditStepActivePayer interface.
 */
export function instanceOfShadowSubsystemAuditStepActivePayer(value: object): value is ShadowSubsystemAuditStepActivePayer {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ShadowSubsystemAuditStepActivePayerFromJSON(json: any): ShadowSubsystemAuditStepActivePayer {
    return ShadowSubsystemAuditStepActivePayerFromJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepActivePayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemAuditStepActivePayer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'payer_id': json['payer_id'] === undefined ? undefined : json['payer_id'] === null ? null : json['payer_id'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function ShadowSubsystemAuditStepActivePayerToJSON(json: any): ShadowSubsystemAuditStepActivePayer {
    return ShadowSubsystemAuditStepActivePayerToJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepActivePayerToJSONTyped(value?: ShadowSubsystemAuditStepActivePayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'payer_id': value['payer_id'],
        'type': value['type'],
    };
}

